import { AfterViewInit, Directive, ElementRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudItemComponent, UserStorage, requiredValidator } from '@scisys-uim/uim-common';
import { AssetsUser, MECHANICAL_ASPECT_TYPE, MechanicalAspect, RefCode, setDefaultLocationFromUser } from 'assets-model';
import { MechanicalAspectService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class MechanicalAspectItemComponentBase extends CrudItemComponent<MechanicalAspect, number> implements OnInit, AfterViewInit {

  protected systemConfig: any;
  
  public form: FormGroup;
  
  havsRagStatusSelectionList: RefCode[];

  wbvRagStatusSelectionList: RefCode[];


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected mechanicalAspectService: MechanicalAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(MECHANICAL_ASPECT_TYPE, fb, elementRef, router, route, userStorage, dialog, mechanicalAspectService, injector, snackbar);
  }

  createNewItem() {
    return new MechanicalAspect();
  }
  
  createForm(): FormGroup {
    return this.fb.group({
      aspectAssetId: [null, []],
      havs: [null, [requiredValidator,]],
      havsRagStatus: [null, []],
      lockVersion: [null, []],
      wbv: [null, [requiredValidator,]],
      wbvRagStatus: [null, []]
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }
  
  protected initSystemConfig(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initSystemConfig(config);
  }
  
  setDefaults() {
    if (!this.readOnly && this.createMode) {
      setDefaultLocationFromUser(this.userDetails, this.item);

      // re-trigger updating drop-downs.
      this.itemSet();
    }
    this.setDefaultDisabledFields();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }
    if (!this.createMode) {
      this.aspectAssetId?.disable();
    }
  }
  
  
  havsChanging(value: boolean, unsetDependents: boolean = true) {}
  
  havsChanged(value: boolean, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.havsChangedByUser(value, unsetDependents);
    }
  }  
  
  havsChangedByUser(value: boolean, unsetDependents: boolean = true) {
  }
  
  havsRagStatusLoadSelectionList() {
    this.refCodeStorage.getDomainElements('RAG_STATUS').subscribe(
      data => {
        this.havsRagStatusSelectionList = data;
      }
    );
  }

  havsRagStatusChanging(value: string, unsetDependents: boolean = true) {}
  
  havsRagStatusChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.havsRagStatusChangedByUser(value, unsetDependents);
    }
  }  
  
  havsRagStatusChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  lockVersionChanging(value: number, unsetDependents: boolean = true) {}
  
  lockVersionChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.lockVersionChangedByUser(value, unsetDependents);
    }
  }  
  
  lockVersionChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  wbvChanging(value: boolean, unsetDependents: boolean = true) {}
  
  wbvChanged(value: boolean, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.wbvChangedByUser(value, unsetDependents);
    }
  }  
  
  wbvChangedByUser(value: boolean, unsetDependents: boolean = true) {
  }
  
  wbvRagStatusLoadSelectionList() {
    this.refCodeStorage.getDomainElements('RAG_STATUS').subscribe(
      data => {
        this.wbvRagStatusSelectionList = data;
      }
    );
  }

  wbvRagStatusChanging(value: string, unsetDependents: boolean = true) {}
  
  wbvRagStatusChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.wbvRagStatusChangedByUser(value, unsetDependents);
    }
  }  
  
  wbvRagStatusChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  

  control(name: string) {
    return this.form ? this.form.get(name) : null;
  }

  get aspectAssetId() {
    return this.control('aspectAssetId');
  }
  
  get havs() {
    return this.control('havs');
  }
  
  get havsRagStatus() {
    return this.control('havsRagStatus');
  }
  
  get lockVersion() {
    return this.control('lockVersion');
  }
  
  get wbv() {
    return this.control('wbv');
  }
  
  get wbvRagStatus() {
    return this.control('wbvRagStatus');
  }
  
}





